<template>
  <div class="welcome-container">
    <div class="container">
      <div class="columns is-centered">
        <div class="column is-8-desktop is-10-tablet">
          <div class="card">
            <header class="card-header">
              <div class="card-header-title is-block has-text-centered">
                <!-- <img
                  width="180px"
                  height="180px"
                  src="@/assets/logo2.png"
                  alt="Logo"
                /> -->
                <h1
                  class="title is-spaced is-size-2-desktop is-size-4-mobile has-text-weight-bold mt-4 mb-2"
                >
                  ¡Te damos la bienvenida a la encuesta!
                </h1>
                <p
                  class="subtitle is-size-5-desktop is-size-6-mobile has-text-grey"
                >
                  Mytho - Cultura Organizacional
                </p>
              </div>
            </header>

            <div class="card-content">
              <div class="content has-text-centered">
                <p class="has-text-grey-dark mb-5" style="line-height: 1.6;">
                  ¡Hola! {{ survey.name || "" }}<br />
                  Nos encanta que estés aquí. Antes de empezar, hay algunas
                  cosas importantes que debes saber:
                </p>

                <div class="info-box">
                  <ul class="info-list">
                    <li class="info-item">
                      <span class="bullet has-text-primary">•</span>
                      <span
                        >Tu participación es 100% voluntaria, pero necesaria
                        para que la organización pueda recibir resultados de tu
                        grupo.</span
                      >
                    </li>
                    <li class="info-item">
                      <span class="bullet has-text-primary">•</span>
                      <span
                        >Tus respuestas son totalmente confidenciales
                        <span class="has-text-weight-semibold"
                          >(cumplimos con la Ley 1581 de 2012 📜).</span
                        ></span
                      >
                    </li>
                    <li class="info-item">
                      <span class="bullet has-text-primary">•</span>
                      <span
                        >Los resultados serán entregados solo en forma de grupos
                        de cinco (5) o más personas, ¡nada individual! 🔒</span
                      >
                    </li>
                    <li class="info-item">
                      <span class="bullet has-text-primary">•</span>
                      <span
                        >Estos datos serán usados por Siete S.A.S. para
                        investigación, siempre manteniendo la confidencialidad
                        de los mismos.</span
                      >
                    </li>
                    <li class="info-item">
                      <span class="bullet has-text-primary">•</span>
                      <span> Cumplimos con la ley 1090 del 2006 </span>
                    </li>
                  </ul>
                </div>

                <p class="has-text-grey-dark mt-5" style="line-height: 1.6;">
                  No te preocupes, no hay respuestas correctas o incorrectas.
                  Solo queremos tu percepción honesta sobre la organización 🌟.
                </p>
              </div>
            </div>

            <footer class="card-footer">
              <div class="card-footer-item">
                <b-button
                  v-tooltip="{ content: 'Ayuda', classes: 'cultura-tooltip' }"
                  @click="handleHelp"
                  icon-left="help-circle-outline"
                  size="is-medium"
                >
                </b-button>
                <b-button
                  type="is-primary"
                  size="is-medium"
                  expanded
                  @click="handleContinue"
                >
                  Continuar
                </b-button>
              </div>
            </footer>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "Welcome",
  data() {
    return {
      help: false,
    };
  },
  props: {
    survey: Object,
  },
  methods: {
    handleContinue() {
      this.$emit("continue");
    },
    handleHelp() {
      this.$buefy.dialog.alert({
        title: "Ayuda",
        message: `<p>
          Si tienes alguna duda o necesitas ayuda, estamos aquí para ti.
          <br> <br>
          Escribe a <a href="mailto:mariae@sietegho.com">mariae@sietegho.com</a> y con gusto te ayudaremos 💌.
        </p>`,
        canCancel: ["escape", "outside"],
        confirmText: "Cerrar",
        cancelText: null,
        type: "is-primary",
      });
    },
  },
};
</script>

<style scoped>
.welcome-container {
  min-height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 2rem 1rem;
  background-color: #f5f5f5;
}

.card {
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
}

.card-header {
  align-items: center !important;
}

.card-header-title {
  padding: 2rem 1.5rem;
}

.card-content {
  padding: 1.5rem;
}

.info-box {
  background-color: rgba(245, 245, 245, 0.8);
  border-radius: 6px;
  padding: 1.5rem;
  text-align: left;
}

.info-list {
  list-style: none;
  margin: 0;
  padding: 0;
}

.info-item {
  display: flex;
  align-items: flex-start;
  gap: 0.5rem;
  margin-bottom: 0.75rem;
  font-size: 0.875rem;
  color: #4a4a4a;
}

.info-item:last-child {
  margin-bottom: 0;
}

.bullet {
  font-weight: bold;
  font-size: 1.2rem;
  line-height: 1;
  flex-shrink: 0;
}

.card-footer-item {
  padding: 1.5rem;
  display: flex;
  gap: 0.5rem;
}

@media screen and (max-width: 768px) {
  .welcome-container {
    padding: 1rem;
  }

  .card-header-title {
    padding: 1.5rem 1rem;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/cultura/sections/survey/Welcome.vue